// Angular
import { Component, OnInit, Inject, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// RxJS
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../../core/reducers';
import { Permission, AuthService } from 'src/app/core/auth';
import { Meeting } from 'src/app/core/timeline';
import { CommunicationsService } from '../../../../../../core/timeline/_services';
import { SharedHttpRequestService } from '../../../../../../core/lists/_services';
import { tagsViewContext } from '../../../../../../core/lists/_services/shared-http-request.service';

@Component({
  selector: 'kt-meeting-edit-dialog',
  templateUrl: './meeting-view-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class MeetingViewDialogComponent implements OnInit, OnDestroy {
  // Public properties
  meeting: Meeting;
  meeting$: Observable<Meeting>;
  hasFormErrors = false;
  viewLoading = false;
  loadingAfterSubmit = false;
  allPermissions$: Observable<Permission[]>;
  meetingPermissions: Permission[] = [];

  private componentSubscriptions: Subscription;
  attachmentData = { communication_id: 0, type: '' };
  loadingTags = true;
  meetingTags = [];

  /**
   * Component constructor
   *
   * @param dialogRef: MatDialogRef<ViewDialogComponent>
   * @param data: any
   * @param store: Store<AppState>
   */
  constructor(
    public dialogRef: MatDialogRef<MeetingViewDialogComponent>,
    private auth: AuthService,
    private communicationsService: CommunicationsService,
    private sharedHttpRequestService: SharedHttpRequestService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.meeting = this.data.meeting;
    this.attachmentData = { communication_id: this.meeting.id, type: 'MEETING' };
    this.loadTags();
  }

  ngOnDestroy() {
    if (this.componentSubscriptions) {
      this.componentSubscriptions.unsubscribe();
    }
  }

  getReceivers(type: number) {
    switch (type) {
      case 1:
        return this.meeting.receivers
          .filter((r) => r.type !== 'RESPONSIBLE_PERSON')
          .map((r) => r.name);
      default:
        return this.meeting.receivers
          .filter((r) => r.type === 'RESPONSIBLE_PERSON')
          .map((r) => r.name);
    }
  }

  private loadTags() {
    this.sharedHttpRequestService
      .getTagsForView(this.meeting.id, tagsViewContext.COMMUNICATION)
      .subscribe(
        (tags) => {
          this.meetingTags = tags.data;
          this.loadingTags = false;
        },
        () => {
          this.meetingTags = [];
          this.loadingTags = false;
        },
      );
  }

  // tslint:disable-next-line:variable-name
  getDate(from_time: string) {
    return new Date(from_time + ' GMT').toLocaleString();
  }
  estimateDuration(duration) {
    if (duration % 1 === 0 || duration % 1 === 0.5) {
      return duration + ' Hours';
    }
    return Math.floor(duration * 60) + ' Mins';
  }
}
